import React from 'react'

import { SliderItem } from '@src/Application/Types/ComponentTypes'

import { Image, ImageWrapper, LogoItems, Logos, Wrapper } from './LogoCarousel.styled'

type Props = {
    logos: SliderItem[]
}

export const LogoCarousel = (props: Props): JSX.Element => {
    const { logos } = props

    return (
        <Wrapper data-testid="logo-carousel">
            <Logos>
                <LogoItems $count={logos.length}>
                    {logos.map((logo, i) => (
                        <ImageWrapper key={logo.image.localFile.publicURL}>
                            <Image image={logo.image} />
                        </ImageWrapper>
                    ))}
                </LogoItems>
                <LogoItems $count={logos.length}>
                    {logos.map((logo, i) => (
                        <ImageWrapper key={logo.image.localFile.publicURL}>
                            <Image image={logo.image} />
                        </ImageWrapper>
                    ))}
                </LogoItems>
                <LogoItems $count={logos.length}>
                    {logos.map((logo, i) => (
                        <ImageWrapper key={logo.image.localFile.publicURL}>
                            <Image image={logo.image} />
                        </ImageWrapper>
                    ))}
                </LogoItems>
            </Logos>
        </Wrapper>
    )
}
